module.exports = "/images/vendor/greenmotion-shared/brand/usave/svgs/movemee/select-down-arrow.svg?fb1c6a6b8bbfacc17f643946dc054ed4";